export const getUserUuidHeaders = (uuid: string) => ({
        'user_uuid': uuid,

        // in some cases, browsers seemingly drop the user_uuid header (or it's lost somewhere between the client and the API GW)
        // the header is seen in the network diagnostics but the backend never receives it. A second parameter has been added
        // with the X prefix - the assumption is that something may be removing headers that are seen as invalid.
        'X-Class-User-UUID': uuid
    });
